<template>
  <div class="page">
    <van-list v-model="loading" loading-text="loading..." :finished="finished" finished-text="" @load="fetchList">
    <div class="content-item" v-for="item in list" :key="item.id" @click="_viewDetail(item)">
      <div class="content-id">{{item.id}}</div>
      <div class="content-img" v-if="item.images">
        <img :src="item.images" />
      </div>
      <div class="content-info" v-html="item.info"></div>
    </div>
    </van-list>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import config from "../config";
import { get } from "lodash";

export default {
  name: "Contentlist",
  data() {
    return {
      list: [],
      page: 1,
      loading: false,
      finished: false
    };
  },
  computed: {
    ...mapState(["lang"])
  },
  created() {
  },
  methods: {
    fetchList() {
      Utils.$ajax({
        url: `/user/content&page_id=${this.page}&page_size=5`
      }).done(res => {
        let list = get(res, "data.list", []);
        if (res.code != 0) {
          this.finished = true;
          this.$toast(res.msg);
          return;
        }
        if(list.length < 5){
            this.finished = true;
        }
        this.list = this.list.concat(list);
        this.page++;
      }).always(res=>{
        this.loading = false;
      })
    },
    _viewDetail(item) {
      this.$router.push({
          name: 'Contentdetail',
          params: {data:item}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  min-height: rem(1020);
  background: #fffbcb;
}
.content-item {
  padding: 1em 2em;
  border-bottom: 1px #333 solid;
  .content-id {
    font-weight: bold;
    font-size: 1.8em;
    text-align: center;
  }
  .content-img {
    margin-top: .6em;
    text-align: center;
    img{
      max-width: rem(600);
      max-height: rem(303);
    }
  }
  .content-info {
    margin-top: .6em;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contentlist.vue